import getters from './getters'
import actions from './actions'
import mutations from './mutations'
const state = {
    serviceJob: {
        serviceId : null,
        serviceCategory : null,
        jobs: [],
    },
    jobList: []
}

const serviceJob = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default serviceJob;